import { Entry } from '../Entry'

export function Entry20240911() {
  return (
    <Entry title="Set 11 2024 - v3.8.3">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16008/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
